const clearFilesReducer = (state, action) => ({
  ...state,
  files: action.payload.files
});

export default clearFilesReducer;
